/**
 * Step hierarchy and the associated ids.
 */
export const STEP_PATHS = {
  goalObjective: { id: 'selectGoalObjective' },
  goalType: { id: 'selectGoalType' },
  goalDetails: {
    id: 'editGoalDetails',
    normalGoal: { id: 'editGoalDetails.normalGoal' },
    enhancedConversions: { id: 'editGoalDetails.enhancedConversions' },
    smartGoal: { id: 'editGoalDetails.smartGoal' },
  },
  tagSetup: {
    id: 'setupTag',
    selectTag: { id: 'setupTag.selectTag' },
    noTag: {
      id: 'setupTag.noTag',
      selectTagMethod: { id: 'setupTag.noTag.selectTagMethod' },
      installTag: { id: 'setupTag.noTag.installTag' },
      emailTag: { id: 'setupTag.noTag.emailTag' },
      platformTag: { id: 'setupTag.noTag.platformTag' },
      gtmTag: { id: 'setupTag.noTag.gtmTag' },
      platformTagInstructions: { id: 'setupTag.noTag.platformTagInstructions' },
    },
    addEventTag: { id: 'setupTag.addEventTag' },
    addEventTagWithClarity: { id: 'setupTag.addEventTagWithClarity' },
    eventTagChoice: { id: 'setupTag.eventTagChoice' },
    setupEnhancedConv: { id: 'setupTag.setupEnhancedConv' },
  },
  endFlow: {
    id: 'endFlow',
  },
};
